// extracted by mini-css-extract-plugin
export default {"container":"SessionInformation_container__uPaH6","heading":"SessionInformation_heading__cOKiU"};